
interface NavItemActiveProps {
  disabled?: boolean;
  external?: boolean;
  href?: string;
  matcher?: { type: 'startsWith' | 'equals'; href: string };
  pathname: string;
}

export function isNavItemActive({ disabled, external, href, matcher, pathname }: NavItemActiveProps): boolean {
  if (disabled || external || !href) {
    return false;
  }

  if (matcher) {
    if (matcher.type === 'startsWith') {
      return pathname.startsWith(matcher.href);
    }
    return pathname === matcher.href;
  }

  // For workflows & tasks menu item
  if (href.includes('/workflows')) {
    return pathname.includes('/workflows') || 
           pathname.includes('/workflow/view') ||
           pathname.includes('/workflow/subscribe');
  }

  // For assessments menu item
  if (href.includes('/assessment')) {
    return pathname.includes('/assessments') ||
           pathname.includes('/assessment/create') || 
           pathname.includes('/assessment/form') ||
           pathname.includes('/assessment/view') ||
           pathname.includes('/assessment/details');
  }

  // For clients menu item
  if (href.includes('/clients')) {
    return pathname.includes('/clients') || 
           pathname.includes('/clients/view');
  }

  if (href.includes('/users')) {
    return pathname.includes('/users') || 
           pathname.includes('/users/view') ||
           pathname.includes('/users/editbase');
  }

  if (href.includes('/agents')) {
    return pathname.includes('/agents') || 
           pathname.includes('/agents/view');
  }

  if (href.includes('/companies')) {
    return pathname.includes('/companies') || 
           pathname.includes('/companies/view') ||
           pathname.includes('/companies/editbase') ||
           pathname.includes('/companies/editServiceInfo');
  }

  if (href.includes('/profile')) {
    return pathname.includes('/profile') || 
           pathname.includes('/companyProfile') ||
           pathname.includes('/companyEditServiceInfo')
  }

  if (href.includes('/programs')) {
    return pathname.includes('/programs') || 
           pathname.includes('/programs/view');
  }

  if (href.includes('/subscriptions')) {
    return pathname.includes('/company/subscriptionDetails') ||
           pathname.includes('/admin/subscriptions') ||
           pathname.includes('/subscriptions');
  }

  // Default path matching
  return pathname === href;
}
